import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { fetchEmployerPublicSubscription } from "./EmployerPublicSubscriptionAPI";

const initialState = {
    data: [],
    loading: false,
    error: null,
};

export const fetchEmployerPublicSubscriptionAsync = createAsyncThunk(
    "PublicSubscription/fetch",
    async (_, { rejectWithValue }) => {
        try {
            const data = await fetchEmployerPublicSubscription();
            const resp = data?.response

            if (!resp) {
                throw new Error("Invalid response structure");
            }
            return resp;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
)



const EmployerPublicSubscriptionSlice = createSlice({
    name: "EmployerPublicSubscription",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchEmployerPublicSubscriptionAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchEmployerPublicSubscriptionAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.error = null;
            })
            .addCase(fetchEmployerPublicSubscriptionAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
            });
    }
})


export const selectEmployerPublicSubscription = (state) => state.employerpublicsubscription.data;
export default EmployerPublicSubscriptionSlice.reducer;

